"use client";

import Link from 'next/link';
import React from 'react'
import { Swiper, SwiperSlide } from 'swiper/react';

import "swiper/css";
import { Autoplay, Navigation } from 'swiper/modules';
import urls from '@/utils/urls/urls';

export default function BannerSlide({ data }: { data: any }) {
    return (
        <>
            <div className="hero-slider owl-carousel">
                <Swiper className="mySwiper hero-slider owl-carousel"

                    slidesPerView={1}
                    spaceBetween={0}
                    modules={[Autoplay, Navigation]}
                    navigation={{
                        prevEl: ".destination-card2-prev",
                        nextEl: ".destination-card2-next",
                    }}
                // breakpoints={{
                //     320: { slidesPerView: 1, spaceBetween: 10 },
                //     640: { slidesPerView: 2, spaceBetween: 20 },
                //     1024: { slidesPerView: 3, spaceBetween: 30 }
                // }}

                // loop={true}
                >
                    {data?.map((banner: any, index: any) => (
                        <SwiperSlide
                            key={index}
                            className="hero-single"
                            style={{
                                backgroundImage: `url(${urls?.image}${banner?.image})`
                            }}
                        >
                            <div className="container"
                                style={{ background: "transparent", zIndex: 9999 }}
                            >
                                <div className="row align-items-center"

                                >
                                    <div className="col-md-12 col-lg-6">
                                        <div className="hero-content">
                                            {/*<h6 className="hero-sub-title" data-animation="fadeInUp" data-delay=".25s">*/}
                                            {/*    <i className="far fa-solar-panel"></i> Easy and reliable*/}
                                            {/*</h6>*/}
                                            <h1
                                                className="hero-title"
                                                data-animation="fadeInRight"
                                                data-delay=".50s"
                                            >
                                                {banner?.name}
                                            </h1>
                                            <h2
                                                className="hero-title"
                                                // data-animation="fadeInRight"
                                                data-delay=".50s"
                                                style={{
                                                    fontSize: '50px',
                                                    marginTop: '50px'
                                                }}
                                            >
                                                {banner?.specialText}
                                            </h2>
                                            <p data-animation="fadeInLeft" data-delay=".75s">
                                                {banner?.description}
                                            </p>
                                            {
                                                banner?.btn_link && <div
                                                    className="hero-btn"
                                                    data-animation="fadeInUp"
                                                    data-delay="1s"
                                                >
                                                    <Link href={banner?.btn_link} className="theme-btn">
                                                        {banner?.btn_name}
                                                        <i className="fas fa-arrow-right" />
                                                    </Link>
                                                    {/* <Link href={banner?.btn_link} className="theme-btn2">
                                                {banner?.btn_name}
                                                <i className="fas fa-arrow-right" />
                                            </Link> */}
                                                </div>
                                            }

                                        </div>
                                    </div>
                                </div>
                            </div>
                        </SwiperSlide>
                    ))}
                </Swiper>
            </div>
        </>
    )
}
